<template>
  <el-dialog append-to-body width="500px" :title="isChange ? '编辑食堂' : '新增食堂'" :visible.sync="visible"
    :before-close="reset" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form class="staff-from" v-loading="loading" element-loading-text="加载中…" ref='elFormDom' label-width='110px'
      label-position='right' :model='form.data' :rules='form.rules' :size="subUnitSize">
      <el-form-item label="路线名称" prop="name">
        {{ info.name }}
      </el-form-item>
      <el-form-item label="食堂" prop="address_id">
        <el-select v-model="form.data.address_id" filterable placeholder="请选择" clearable style="width:100%;">
          <el-option v-for="item in storeArr" :label="`${item.name}(${item.merchant_name})`" :value="item.id"
            :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input v-model.trim="form.data.sort" placeholder="如01(排序越小越靠前)" clearable></el-input>
      </el-form-item>
      <el-form-item label="投框编码" v-if="form.data.address_id">
        <template slot="label">
          投框编码
          <el-tooltip content="客户代码+食堂编码组成该食堂投框编码,如未出现投框编码请设置客户代码与食堂编码" placement="top">
            <i class="el-icon-warning" style="color:#e6a23c;"></i>
          </el-tooltip>
        </template>
        {{ getName() }}
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click='toggle(false)'>取消</el-button>
        <el-button type="primary" :loading="form.loading" :disabled="form.loading" @click='confirm'>确定</el-button>
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
import common from '@/util'
export default {
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      isChange: false,
      loading: false,
      form: {
        loading: false,
        data: {
          address_id: '',
          sort: '',
        },
        rules: {
          address_id: [{ required: true, message: '必填', trigger: 'blur' }],
          sort: [{ required: true, message: '必填', trigger: 'blur' }],
        }
      },
      storeArr: [],
      info: {},
    }
  },
  methods: {
    getName() {
      let obj = this.storeArr.find(item => item.id == this.form.data.address_id);
      return obj ? `${obj.simple_name}-${obj.code}` : ''
    },
    init() {
      this.getStore();
      this.form.data = {};
      this.isChange = false;
    },
    getStore() {
      this.$http.get('/admin/path/storeList', { params: { page: 1, count: 10000 } }).then(res => {
        if (res.code === 1) {
          this.storeArr = res.data.list;
        }
      })
    },
    getDetail(row, type) {
      this.getStore();
      if (type == '新增') {
        this.isChange = false;
        this.info = row;
      } else {
        this.isChange = true;
        this.info = row;
        this.form.data.sort = row.sort;
        this.form.data.address_id = row.address_id;
      }
    },
    reset(done) {
      this.isChange = false
      this.info = {}
      this.form.data = {
        address_id: '',
        sort: '',
      }
      this.$refs.elFormDom.resetFields()
      done && done()
    },
    toggle(show) {
      this.visible = show
      !show && this.reset()
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate(valid => {
        if (valid) {
          let _params = {
            id: this.isChange ? this.info.cId : '',
            line_id: this.info.id,
            name: this.form.data.name,
            sort: this.form.data.sort,
            address_id: this.form.data.address_id,
          };
          let apiUrl = '/admin/line/createOrUpdateStore';
          this.form.loading = true;
          this.$http.post(apiUrl, _params).then(res => {
            if (res.code === 1) {
              this.toggle(false);
              this.$emit('refresh')
            }
          }).finally(() => {
            this.form.loading = false;
          })
        }
      })
    },
  }
}
</script>